module.exports = __webpack_public_path__ + "img/amtl-oficina-media.428c9f87.jpg";